/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/utils/request';

/**
 * 登录
 * @param {user_name} 用户名
 * @param {user_pwd} 密码
 */
export function login(params) {
  return request({
    url: '/index/login/login',
    method: 'post',
    data: params
  });
}

// 微信授权登录
export function wechatLogin() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/index/login/getUserInfo';
  return request({
    url: url,
    method: 'post',
    data: params
  });
}

// 退出登陆
export function logout(params) {
  return request({
    url: '/index/login/logout',
    method: 'post',
    data: params
  });
}

// 获取JSSDK的配置数组
export function buildConfig(params) {
  return request({
    url: '/index/login/getTicket',
    method: 'post',
    data: params
  });
}